<template>
  <div class="bg-otherblue py-2 z-20 relative">
    <div class="flex justify-center items-center gap-x-4">
      <a
        href="https://www.facebook.com/ClinicaLaSagradaFamiliaSAS"
        target="_blank"
      >
        <i class="fab fa-facebook-square text-white text-3xl"></i>
      </a>
      <a
        href="https://www.instagram.com/clinicalasagradafamilia"
        target="_blank"
      >
        <i class="fab fa-instagram-square text-white text-3xl"></i>
      </a>
      <a
        href="https://www.youtube.com/@clinicalasagradafamilia8532"
        target="_blank"
      >
        <i class="fab fa-youtube-square text-white text-3xl"></i>
      </a>
    </div>
  </div>

  <footer class="text-gray-600 body-font bg-gray-200 z-20 relative">
    <!-- Encabezado / Logo -->
    <div class="container px-5 pt-5 mx-auto flex justify-center">
      <div class="w-64 text-center">
        <a class="flex justify-center items-center text-gray-900">
          <div
            class="z-20 inline-flex items-center justify-center w-24 mb-6 rounded-full"
          >
            <!-- Logo opcional -->
          </div>
        </a>
      </div>
    </div>

    <!-- Contenido principal del footer -->
    <div class="container mx-auto px-5 py-4 flex flex-wrap justify-between">
      <!-- Empresas -->
      <div class="lg:w-1/4 md:w-1/2 w-full px-4 mb-4">
        <Empresas />
      </div>
      <!-- Información de contacto -->
      <div class="lg:w-1/4 md:w-1/2 w-full px-4 mt-12">
        <h2
          class="text-otherblue title-font font-bold text-black text-2xl mb-4"
        >
          Contacto
        </h2>
        <ul class="text-left md:text-lg text-black space-y-3 leading-relaxed">
          <li><strong>PBX:</strong> +57 (606) 746 62 62</li>
          <li><strong>Call Center:</strong> (606) 746 62 62 Ext. 1</li>
          <li>
            <strong>Dirección:</strong><br />Carrera 15 – Calle 9, Armenia,
            Quindío
          </li>
          <li>
            <strong>Email:</strong>
            <a
              href="mailto:siau@clinicasagradafamilia.net"
              class="text-otherblue hover:underline"
            >
              siau@clinicasagradafamilia.net
            </a>
          </li>
        </ul>
      </div>

      <!-- Nuestra Clínica -->
      <!-- <div class="lg:w-1/4 md:w-1/2 w-full px-4 mt-12">
        <h2 class="title-font font-semibold text-black text-lg mb-3">
          Nuestra Clínica
        </h2>
        <nav class="list-none mb-10">
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/Acerca-De-Nosotros"
              >Acerca de Nosotros</router-link
            >
          </li>
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/Copasst"
              >COPASST</router-link
            >
          </li>
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/En-La-Region"
              >En la Región</router-link
            >
          </li>
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/Servicios"
              >Servicios</router-link
            >
          </li>
        </nav>
      </div> -->

      <!-- SIAU -->
      <!-- <div class="lg:w-1/4 md:w-1/2 w-full px-4 mt-12">
        <h2 class="title-font font-semibold text-black text-lg mb-3">SIAU</h2>
        <nav class="list-none mb-10">
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/Deberes-y-Derechos"
              >Deberes y Derechos</router-link
            >
          </li>
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/PQR"
              >PQR</router-link
            >
          </li>
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/CitasEnLinea"
              >Citas en Línea</router-link
            >
          </li>
          <li>
            <router-link
              class="text-black hover:text-otherblue text-sm"
              to="/Asociacion-De-Usuarios"
              >Asociación de Usuarios</router-link
            >
          </li>
        </nav>
      </div> -->

      <!-- Mapa -->
      <div class="lg:w-1/4 md:w-1/2 w-full px-4 mb-4">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3977.3077332175963!2d-75.6708774242907!3d4.538511743040752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e38f5ab28c3ac41%3A0x494b1bfc7b7ecfca!2sCl%C3%ADnica%20La%20Sagrada%20Familia!5e0!3m2!1ses!2sco!4v1752585461163!5m2!1ses!2sco"
          width="100%"
          height="300"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>

    <!-- Footer inferior con imagen y derechos -->
    <div class="bg-gray-50">
      <div
        class="container mx-auto py-4 px-5 flex flex-wrap justify-between items-center"
      >
        <a href="https://www.supersalud.gov.co/" target="_blank">
          <img src="@/assets/supersalud.png" alt="Logo" class="h-32 w-auto" />
        </a>
        <p class="text-sm text-gray-600 text-right">
          Copyright © 2025 IT MANAGEMENT ZOMAC S.A.S
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import Empresas from "./EmpresasUros.vue";

export default {
  name: "Footer",
  components: {
    Empresas,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
footer h2 {
  color: #333;
  font-size: 2rem;
  font-weight: 600;
}

footer nav a {
  display: block;
  margin-bottom: 0.5rem;
}

footer nav a:hover {
  color: #1e3a8a;
  text-decoration: underline;
}

footer .bg-otherblue {
  background-color: #1e3a8a;
}

footer .bg-gray-50 {
  background-color: #f9fafb;
}
</style>
